import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/alumniPageImages/alumniHero.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/alumniPageImages/alumniHeroMobile.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AluminiComponents/AlumniPodcast/AlumniPodcast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AluminiComponents/LegacyExcellence/LegacyExcellence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
